<script setup>
const props = defineProps({
  maxHeight: {
    type: String
  },
  hideScrollbar: {
    type: Boolean,
    default: false
  }
});
</script>

<template>
  <div class="scroll-area-wrapper" :class="{ 'scroll-area-wrapper--hide-scrollbar': hideScrollbar }">
    <div
      class="scroll-area"
      :class="{ 'scroll-area--hide-scrollbar': hideScrollbar }"
      :style="{ maxHeight: maxHeight }"
    >
      <div class="scroll-area__content">
        <slot />
      </div>
    </div>
  </div>
</template>

<style scoped>
.scroll-area-wrapper {
  width: 100%;
  position: relative;
}

.scroll-area {
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
}

.scroll-area__content {
  padding-right: 12px;
}

/* Custom scrollbar styling */
.scroll-area::-webkit-scrollbar {
  width: 10px;
}

.scroll-area::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

.scroll-area::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

.scroll-area::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
  background-clip: padding-box;
}

/* Firefox scrollbar */
.scroll-area {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

/* Hide scrollbar option */
.scroll-area--hide-scrollbar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.scroll-area--hide-scrollbar::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.scroll-area-wrapper--hide-scrollbar .scroll-area__content {
  padding-right: 0;
}
</style>
